import React from 'react';
export function TermsContent() {
  return <div className="prose prose-burgundy max-w-none" data-id="element-219">
      <div className="space-y-6 text-burgundy-900" data-id="element-220">
        <section data-id="element-221">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-222">
            1. Aceptación de los Términos
          </h3>
          <p className="text-burgundy-800 leading-relaxed" data-id="element-223">
            Al adquirir y utilizar la guía "7 Noches Para Volver a Tocarnos (Sin
            Vergüenza)", aceptas estos términos y condiciones en su totalidad.
            Si no estás de acuerdo con alguna parte de estos términos, no debes
            utilizar este producto.
          </p>
        </section>

        <section data-id="element-224">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-225">
            2. Uso del Producto
          </h3>
          <p className="text-burgundy-800 leading-relaxed mb-3" data-id="element-226">
            Esta guía es para uso personal y privado. Está diseñada para parejas
            adultas (mayores de 18 años) que buscan mejorar su intimidad de
            manera consensuada y respetuosa.
          </p>
          <ul className="list-disc list-inside space-y-2 text-burgundy-800" data-id="element-227">
            <li data-id="element-228">
              No está permitida la reproducción, distribución o reventa del
              contenido
            </li>
            <li data-id="element-229">
              El contenido es solo para uso personal dentro de tu relación
            </li>
            <li data-id="element-230">No se permite compartir el PDF con terceros</li>
          </ul>
        </section>

        <section data-id="element-231">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-232">
            3. Naturaleza del Contenido
          </h3>
          <p className="text-burgundy-800 leading-relaxed" data-id="element-233">
            Esta guía ofrece sugerencias y ejercicios para mejorar la intimidad
            en parejas. No es terapia profesional, asesoramiento médico ni
            psicológico. Si experimentas problemas graves en tu relación, te
            recomendamos buscar ayuda profesional.
          </p>
        </section>

        <section data-id="element-234">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-235">
            4. Consentimiento y Respeto
          </h3>
          <p className="text-burgundy-800 leading-relaxed" data-id="element-236">
            Este producto está diseñado para relaciones basadas en el respeto
            mutuo y el consentimiento. No debe utilizarse en situaciones donde
            exista coerción, presión o falta de consentimiento. Ambas personas
            deben participar voluntariamente.
          </p>
        </section>

        <section data-id="element-237">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-238">
            5. Política de Reembolso
          </h3>
          <p className="text-burgundy-800 leading-relaxed" data-id="element-239">
            Debido a la naturaleza digital del producto y la entrega inmediata,
            no ofrecemos reembolsos una vez completada la compra y descargado el
            contenido.
          </p>
        </section>

        <section data-id="element-240">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-241">
            6. Propiedad Intelectual
          </h3>
          <p className="text-burgundy-800 leading-relaxed" data-id="element-242">
            Todo el contenido de esta guía, incluyendo textos, diseños y
            conceptos, está protegido por derechos de autor. María Dohgrato
            retiene todos los derechos de propiedad intelectual.
          </p>
        </section>

        <section data-id="element-243">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-244">
            7. Limitación de Responsabilidad
          </h3>
          <p className="text-burgundy-800 leading-relaxed" data-id="element-245">
            El uso de esta guía es bajo tu propia responsabilidad. No nos
            hacemos responsables de los resultados individuales o de cualquier
            consecuencia derivada del uso del contenido.
          </p>
        </section>

        <section data-id="element-246">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-247">
            8. Modificaciones
          </h3>
          <p className="text-burgundy-800 leading-relaxed" data-id="element-248">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios serán efectivos inmediatamente después de su
            publicación.
          </p>
        </section>

        <div className="mt-8 pt-6 border-t border-cream-300" data-id="element-249">
          <p className="text-sm text-burgundy-600 italic" data-id="element-250">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>
        </div>
      </div>
    </div>;
}